import { ACTIONS } from '@r1-frontend/shared/constants/analytics';

import lazyCallbackDataLayerPush from '~/src/components/LazyCallBack/helpers/lazyCallbackDataLayerPush';

const sendStartInputName = (tariffName: string): void => {
    lazyCallbackDataLayerPush({
        action: ACTIONS.started,
        label: `${tariffName} | short_form`,
    });
};

export default sendStartInputName;
